module.exports = __webpack_public_path__ + "static/media/double-yellow-card.svg.d753a5f5.png";